/* eslint-disable @typescript-eslint/no-unused-vars */
import compose from 'compose-function';
import { withRouter } from './withRouter';
import { withTonConnect } from './withTonConnect';
import { withToaster } from './withToaster';
export const withProviders = compose(withRouter, withTonConnect, withToaster);
